<template>
  <div class="actionsInRow">
    <v-tooltip top v-if="!hideView && permissions.users.actions.view">
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          icon
          small
          @click.native="$emit('view', user)"
          class="mr-2"
        >
          <v-icon>mdi-eye-outline</v-icon>
        </v-btn>
      </template>
      <span>{{ lang.users.actions.view }}</span>
    </v-tooltip>
    <v-tooltip top v-if="permissions.users.actions.edit">
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          icon
          small
          @click="$emit('edit', user)"
          class="mr-2"
        >
          <v-icon>mdi-account-edit</v-icon>
        </v-btn>
      </template>
      <span>{{ lang.users.actions.edit }}</span>
    </v-tooltip>
    <v-tooltip top v-if="permissions.users.actions.delete">
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          icon
          small
          @click="deleteUser(user)"
          class="mr-2"
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
      <span>{{ lang.users.actions.delete }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'
import users from '../mixins/index'

export default {
  mixins: [ appdata, utils, users ],
  props: {
    user: Object,
    hideView: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style>

</style>
